export default "__VITE_ASSET__QzQ9r$1Z__"